import React, { useEffect, useState } from 'react'
import './user-view.styles.scss'
import { useNavigate, useParams } from 'react-router-dom'
import { getQueryFromFirestore, getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified'
import BackButton from '@/components/SHARED/back-button/back-button.component'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { format } from 'date-fns'

const GameCard = ({ game, navigate }) => {
  if (game.role === 'Player') {
    console.log(game);

  }
  return (
    <div className='user-view-game-row'>
      {game.icon && (
        <ImageContainer src={game.icon} className='user-view-game-icon' />
      )}
      <div className='user-view-game-details'>
        <div className='user-view-game-name'>{game.gameName}</div>
        {game.header && <div className='meta'>{game.header}</div>}
      </div>
      <button
        className='g-button med-btn'
        onClick={() => navigate(`/admin/games/${game.gameId}`)}>
        <FontAwesomeIcon icon={faEye} />
        View
      </button>
    </div>
  )
};

const UserView = () => {

  const { appId } = useParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [createdGames, setCreatedGames] = useState([]);
  const [managerGames, setManagerGames] = useState([]);
  const [playerGames, setPlayerGames] = useState([]);

  useEffect(() => {
    if (!appId) return;
    getUserDetails();
  }, [appId]);

  function getUserDetails() {
    getUniqueDocumentFromFirestore({
      path: `users/${appId}`,
      once: true,
      callback: (user) => {
        if (!user) return;
        setUserData(user);
        fetchCreatedGames(user);
        fetchRegistrations();
      }
    });
  }

  function fetchCreatedGames(user) {
    let gameIds = [];
    if (Array.isArray(user.gamesCreated)) {
      gameIds = user.gamesCreated;
    } else if (user.gamesCreated && typeof user.gamesCreated === 'object') {
      gameIds = Object.keys(user.gamesCreated);
    }
    if (gameIds.length === 0) return;

    const games = [];
    let fetched = 0;
    gameIds.forEach(gameId => {
      getUniqueDocumentFromFirestore({
        path: `games/${gameId}`,
        once: true,
        callback: (gameData) => {
          if (gameData) {
            games.push({ ...gameData, gameId });
          }
          fetched++;
          if (fetched === gameIds.length) {
            setCreatedGames([...games]);
          }
        }
      });
    });
  }

  function fetchRegistrations() {
    getQueryFromFirestore({
      path: 'registrations',
      collectionGroup: true,
      once: true,
      queryArray: [{ field: 'list', operator: 'array-contains', value: appId }],
      callback: (registrations) => {
        const managerRegs = [];
        const playerRegs = [];

        Object.values(registrations).forEach(reg => {
          const roles = reg.roles?.[appId] || [];
          if (roles.includes('manager') || roles.includes('distributor')) {
            managerRegs.push({ ...reg, role: roles.includes('manager') ? 'Manager' : 'Distributor' });
          } else if (roles.includes('player')) {
            playerRegs.push({ ...reg, role: 'Player' });
          }
        });

        fetchGameDataForRegistrations(managerRegs, setManagerGames);
        fetchGameDataForRegistrations(playerRegs, setPlayerGames);
      }
    });
  }

  function fetchGameDataForRegistrations(regs, setter) {
    if (regs.length === 0) {
      setter([]);
      return;
    }
    const enriched = [];
    let fetched = 0;
    regs.forEach(reg => {
      getUniqueDocumentFromFirestore({
        path: `games/${reg.gameId}`,
        once: true,
        callback: (gameData) => {
          enriched.push({ ...gameData, role: reg.role });
          fetched++;
          if (fetched === regs.length) {
            setter([...enriched]);
          }
        }
      });
    });
  }

  return (
    <div className='user-view'>
      <div className='g-card user-view-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className='g-space-1'></div>
        {
          userData
            ?
            <div>
              <div className='card-title'>
                {userData.fName} {userData.lName}
              </div>
              <div className='user-view-meta'>
                <div className='meta'>{userData.email}</div>
                {userData.ts_joined && (
                  <div className='meta'>
                    Joined: {format(new Date(userData.ts_joined), 'Pp')}
                  </div>
                )}
                {userData.appId && (
                  <div className='meta'>ID: {userData.appId}</div>
                )}
              </div>
              <hr />

              <div className='user-view-section'>
                <div className='section-title'>
                  Created Games ({createdGames.length})
                </div>
                <div className='g-space-0-5'></div>
                {
                  createdGames.length > 0
                    ?
                    createdGames.map(game => (
                      <GameCard
                        key={game.gameId}
                        game={game}
                        path={game.gameId}
                        navigate={navigate} />
                    ))
                    :
                    <div className='meta'>No games created.</div>
                }
              </div>

              <hr />

              <div className='user-view-section'>
                <div className='section-title'>
                  Manager / Distributor Games ({managerGames.length})
                </div>
                <div className='g-space-0-5'></div>
                {
                  managerGames.length > 0
                    ?
                    managerGames.map((reg, i) => (
                      <GameCard
                        key={i}
                        game={reg}
                        path={reg.path}
                        navigate={navigate} />
                    ))
                    :
                    <div className='meta'>Not enrolled as manager or distributor in any games.</div>
                }
              </div>

              <hr />

              <div className='user-view-section'>
                <div className='section-title'>
                  Player Games ({playerGames.length})
                </div>
                <div className='g-space-0-5'></div>
                {
                  playerGames.length > 0
                    ?
                    playerGames.map((reg, i) => (
                      <GameCard
                        key={i}
                        game={reg}
                        path={reg.path}
                        navigate={navigate} />
                    ))
                    :
                    <div className='meta'>Not enrolled as a player in any games.</div>
                }
              </div>
            </div>
            :
            <div className='meta center-col'>Loading user data...</div>
        }
      </div>
    </div>
  );
}

export default UserView
